import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Sidebar from './components/Sidebar';
import Vehicles from './components/Vehicles';
import Owners from './components/Owners';
import ServiceRecords from './components/ServiceRecords';
import Dashboard from './components/Dashboard';
import Warranties from './components/Warranties';
import Insurance from './components/Insurance';
import Inspections from './components/Inspections';
import Accidents from './components/Accidents';
import Financing from './components/Financing';
import Recalls from './components/Recalls';
import FuelRecords from './components/FuelRecords';
import Documents from './components/Documents';
import Appraisals from './components/Appraisals';
import Search from './components/Search';
import Notifications from './components/Notifications';
import Calendar from './components/Calendar';
import BulkOperations from './components/BulkOperations';
import Reports from './components/Reports';
import SmartSearch from './components/SmartSearch';
import PredictiveMaintenance from './components/PredictiveMaintenance';
import VINDecoder from './components/VINDecoder';
import WorkflowAutomation from './components/WorkflowAutomation';
import AIInsights from './components/AIInsights';
import { trackPageView } from './analytics';
import './App.css';

function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    try {
      trackPageView(location.pathname + location.search);
    } catch (error) {
      console.warn('Failed to track page view:', error);
    }
  }, [location]);
  return null;
}

function AppLayout() {
  const location = useLocation();
  const isLanding = location.pathname === '/' || location.pathname === '' || location.pathname === '/Automotive-database-demo';

  if (isLanding) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/Automotive-database-demo" element={<LandingPage />} />
      </Routes>
    );
  }

  return (
    <div className="App">
      <Sidebar />
      <main className="App-main">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/search" element={<Search />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/owners" element={<Owners />} />
          <Route path="/service-records" element={<ServiceRecords />} />
          <Route path="/warranties" element={<Warranties />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/inspections" element={<Inspections />} />
          <Route path="/accidents" element={<Accidents />} />
          <Route path="/financing" element={<Financing />} />
          <Route path="/recalls" element={<Recalls />} />
          <Route path="/fuel-records" element={<FuelRecords />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/appraisals" element={<Appraisals />} />
          <Route path="/bulk-operations" element={<BulkOperations />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/smart-search" element={<SmartSearch />} />
          <Route path="/predictive-maintenance" element={<PredictiveMaintenance />} />
          <Route path="/vin-decoder" element={<VINDecoder />} />
          <Route path="/workflows" element={<WorkflowAutomation />} />
          <Route path="/ai-insights" element={<AIInsights />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  try {
    const getBasename = () => {
      if (window.location.pathname.startsWith('/Automotive-database-demo')) {
        return '/Automotive-database-demo';
      }
      return '';
    };

    return (
      <Router basename={getBasename()}>
        <PageViewTracker />
        <AppLayout />
      </Router>
    );
  } catch (error) {
    console.error('Error in App component:', error);
    return (
      <div style={{
        padding: '40px',
        color: '#fff',
        background: '#0a0e27',
        minHeight: '100vh',
        fontFamily: 'system-ui'
      }}>
        <div style={{
          background: 'rgba(20, 27, 45, 0.6)',
          backdropFilter: 'blur(30px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '20px',
          padding: '32px',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          <h1 style={{ marginTop: 0 }}>Application Error</h1>
          <p>An error occurred while loading the application.</p>
          <pre style={{
            background: '#141b2d',
            padding: '15px',
            borderRadius: '8px',
            overflow: 'auto',
            fontSize: '12px',
            marginTop: '20px'
          }}>
            {error.toString()}
            {error.stack && '\n\n' + error.stack}
          </pre>
        </div>
      </div>
    );
  }
}

export default App;
